import { Note } from "../../../../src/components/note";
import { EncodeUrl } from "../../../../content/blog/2021-05-02-url-encoding-sending-web-form-data/encode-url";
import * as React from 'react';
export default {
  Note,
  EncodeUrl,
  React
};